
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page').then(m => ({ default: m.HomePage })));
const AboutPage = lazy(() => import('../pages/about/page').then(m => ({ default: m.AboutPage })));
const ProductsPage = lazy(() => import('../pages/products/page').then(m => ({ default: m.ProductsPage })));
const FlaggenPage = lazy(() => import('../pages/flaggen/page').then(m => ({ default: m.FlaggenPage })));
const WerbungPage = lazy(() => import('../pages/werbung/page').then(m => ({ default: m.WerbungPage })));
const PromotionPage = lazy(() => import('../pages/promotion/page').then(m => ({ default: m.PromotionPage })));
const ApplicationsPage = lazy(() => import('../pages/applications/page').then(m => ({ default: m.ApplicationsPage })));
const ContactPage = lazy(() => import('../pages/contact/page').then(m => ({ default: m.ContactPage })));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/ueber-uns',
    element: <AboutPage />
  },
  {
    path: '/produkte',
    element: <ProductsPage />
  },
  {
    path: '/flaggen',
    element: <FlaggenPage />
  },
  {
    path: '/werbung',
    element: <WerbungPage />
  },
  {
    path: '/promotion',
    element: <PromotionPage />
  },
  {
    path: '/einsatzbereiche',
    element: <ApplicationsPage />
  },
  {
    path: '/kontakt',
    element: <ContactPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
